import { cn } from "~/lib/utils.ts";

import { ErrorProps, FormError } from ".";
import TheAduseiEditor from "../ui/adusei-editor";
import { SuggestionProps } from "../ui/adusei-editor/suggestion";

interface FormInputProps {
  autoFocus?: boolean;
  readOnly?: boolean;
  label?: string;
  type?: string;
  value?: string | undefined;
  onChange: (option: string | undefined) => void;
  suggestions?: SuggestionProps[];
  errors?: ErrorProps;
  required?: boolean;
  placeholder?: string;
  className?: string;
}
export default function FormRichTextInput({
  label,
  required,
  errors,
  autoFocus,
  readOnly,
  placeholder,
  value,
  suggestions,
  onChange,
  className,
}: FormInputProps) {
  return (
    <div>
      <div className="space-y-1">
        <div
          className={cn("font-Medium text-sm", {
            "text-danger-500": errors?.error,
          })}
        >
          {label} {required && <span className="text-danger-400">*</span>}
        </div>
        <TheAduseiEditor
          defaultValue={value}
          onChange={onChange}
          suggestions={suggestions}
          title={label}
          autoFocus={autoFocus}
          readOnly={readOnly}
          placeholder={placeholder}
          className={cn("", className, {
            "border-danger-500": errors?.error,
          })}
        />
        <FormError error={errors?.error} message={errors?.message} />
      </div>
    </div>
  );
}
